import { AppForms, Chat, theme } from '@/config'
import { appStatusStore } from '@/stores'
import { ChatUser } from '@packages/chat'
import { Text, GroupFormModalPageProps, ModalPage, TextInput, UserList, View, Avatar } from '@/components'
import { WebInputFile } from '@codeleap/types'
import { StaticImageData } from 'next/image'

export function NewGroup(props: GroupFormModalPageProps) {
  const selectedMembers = AppForms.chatGroup.use(s => s.values.members || []) as ChatUser[]
  const file = AppForms.chatGroup.use(s => s.values.file) as WebInputFile
  const groupName = AppForms.chatGroup.use(s => s.values.name) as string

  async function handleCreate() {
    try {
      appStatusStore.set('loading')
      const formValues = AppForms.chatGroup.state.get()
      const members = formValues.members as ChatUser[]

      const response = await Chat.Services.createGroup({
        image: file?.file,
        members,
        name: groupName,
      })

      if (response.ok) {
        AppForms.chatGroup.resetValues()
        props.request.resolve(response.data)
      } else {
      }
    } catch (error) {
      props.request.resolve(null)
      logger.log('Error creating Group:', error)
    } finally {
      appStatusStore.set('idle')
    }
  }

  function handleFileChange(file) {
    AppForms.chatGroup.fields.file.setValue(file)
  }

  return (
    <ModalPage
      title='New group'
      canGoBack
      buttonProps={{
        text: 'Create',
        onPress: handleCreate,
        disabled: (groupName?.length || 0) > 24,
      }}
      {...props}
    >
      <View
        style={['px:3', 'pb:2', 'column', {
          breakpoints: {
            mobile: ['px:2'],
          },
        }]}
      >
        <Avatar
          debugName='profile:avatar'
          badgeIcon={'camera'}
          name={!!groupName?.length ? groupName?.toLocaleUpperCase() : 'New Group'}
          firstNameOnly={false}
          style={['huge', 'margin:auto', 'marginBottom:1']}
          image={file?.preview as unknown as StaticImageData}
          onChange={handleFileChange}
        />

        <TextInput
          {...AppForms.chatGroup.register('name')}
          maxLength={25}
          style={['noError', groupName?.length > 24 ? {
            innerWrapper: { borderColor: theme.colors.fieldNegativeStrokeDefault },
            'innerWrapper:focus': { borderColor: theme.colors.fieldNegativeStrokeDefault }
          } : {}]}
        />
      </View>

      <UserList
        ListHeaderComponent={() => (
          <View style={['px:3', 'pb:0.5', {
            breakpoints: {
              mobile: ['px:2'],
            },
          }]}>
            <Text text={`Members (${selectedMembers.length})`} style={['c1', 'semiBold', { color: theme.colors.textHeadingRegular }]} />
          </View>
        )}
        data={selectedMembers}
        style={{
          wrapper: {
            maxHeight: '60vh',
            overflow: 'auto',
            paddingBottom: theme.spacing.value(2),
          },
        }}
      />
    </ModalPage>
  )
}
